import { Injectable } from '@angular/core';
import { LocaleSwitcherService } from './locale-switcher.service';

// Custom String extension to dynamically load locales in angular
// https://stackblitz.com/edit/angular-5qdq34?file=src%2Flocale-id.service.ts,src%2Fmain.ts

@Injectable({
    providedIn: 'root',
})
export class LocaleId extends String {
    constructor(private localeService: LocaleSwitcherService) {
        super();
    }

    toString(): string {
        return this.localeService.getLocale();
    }

    valueOf(): string {
        return this.toString();
    }
}
